import fetchWithDefaults from '../CommonUtils/fetchWithDefaults';

const { ADV } = window;

export const SET_IS_ACCEPTING_TERMS = 'SET_IS_ACCEPTING_TERMS';
export const SET_IS_FETCHING_TERMS = 'SET_IS_FETCHING_TERMS';
export const SET_RAW_TEXT_TERMS = 'SET_RAW_TEXT_TERMS';
export const SET_ARE_TERMS_ACCEPTED = 'SET_ARE_TERMS_ACCEPTED';
export const SET_ARE_DATA_AGGREGATION_TERMS_ACCEPTED = 'SET_ARE_DATA_AGGREGATION_TERMS_ACCEPTED';

export const setIsAcceptingTerms = isAcceptingTerms => ({
  type: SET_IS_ACCEPTING_TERMS,
  isAcceptingTerms,
});

export const setIsFetchingTerms = isFetchingTerms => ({
  type: SET_IS_FETCHING_TERMS,
  isFetchingTerms,
});

export const setTermsRawText = termsRawText => ({ type: SET_RAW_TEXT_TERMS, termsRawText });

export const setAreTermsAccepted = areTermsAccepted => ({
  type: SET_ARE_TERMS_ACCEPTED,
  areTermsAccepted,
});

export const setAreDataAggregationTermsAccepted = areDataAggregationTermsAccepted => ({
  type: SET_ARE_DATA_AGGREGATION_TERMS_ACCEPTED,
  areDataAggregationTermsAccepted,
});

export const acceptTerms = (clientId, forDataAggregation) => dispatch => {
  dispatch(setIsAcceptingTerms(true));

  let uri;

  if (forDataAggregation) {
    uri = 'Adviser/Adviser/AcceptDataAggregationTermsAndConditions';
  } else if (clientId) {
    uri = `Consumer/Consumer/AcceptTermsAndConditions?clientId=${clientId}`;
  } else {
    uri = 'Adviser/Adviser/AcceptTermsAndConditions';
  }

  ADV.util.request({ uri, type: 'POST', showSpinner: false }).then(() => {
    dispatch(setIsAcceptingTerms(false));
    dispatch(
      forDataAggregation ? setAreDataAggregationTermsAccepted(true) : setAreTermsAccepted(true),
    );
  });
};

const fetchPolicy = policy => {
  return fetch(`${ADV.settings.endpoints.assets}policies/${policy}.html`, {
    credentials: 'omit',
  });
};

const fetchTermsPolicy = async (clientId, forDataAggregation) => {
  if (clientId) {
    return fetchWithDefaults('/Consumer/Consumer/ClientTermsAndConditions');
  }
  if (forDataAggregation) {
    return fetchPolicy('data-aggregation-terms');
  }
  return fetchPolicy('advisor-terms');
};

const getTerms = async (clientId, response) => {
  if (clientId) {
    const {
      payload: {
        viewData: { clientTermsAndConditions: terms },
      },
    } = await response.json();
    return terms;
  }

  return response.text();
};

export const fetchTerms = (clientId, forDataAggregation) => async dispatch => {
  dispatch(setIsFetchingTerms(true));

  const response = await fetchTermsPolicy(clientId, forDataAggregation);

  const terms = await getTerms(clientId, response);

  dispatch(setIsFetchingTerms(false));

  if (clientId) {
    dispatch(setTermsRawText({ clientTCs: terms }));
    return;
  }

  if (forDataAggregation) {
    dispatch(setTermsRawText({ dataAggregationTCs: terms }));
    return;
  }

  dispatch(setTermsRawText({ advisorTCs: terms }));
};
